import { useState } from "react"
import useAgenda from "../../hooks/useAgenda"
import useProcessos from "../../hooks/useProcessos"
import configTiposCompromisso from "./configTiposCompromisso"
import useUsuarios from "../../hooks/useUsuarios"
import { formatarNomeUpper } from "../../utils/formatadores"

const LancarCompromisso = () => {

  const { adicionarCompromisso } = useAgenda()
  const { processos } = useProcessos()
  const { usuarios } = useUsuarios()
  const [actionType, setActionType] = useState(null);

  const [form, setForm] = useState({
    tipo: "",
    colaboradorExecutor: "",
    colaboradorPrazoExecutar: "",
    processoId: "",
    nomeParte: "",
    areaAcao: "",
    dataPrazo: "",
    descricao: ""
  })

  const handleChange = (e) => {

    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value
    })

  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setActionType("salvar") // 👈 Ativa o estado de carregamento
    try {
      const novoCompromisso = {
        tipo: form.tipo,
        colaboradorExecutor: form.colaboradorExecutor,
        colaboradorPrazoExecutar: form.colaboradorPrazoExecutar,
        processoId: form.processoId ? Number(form.processoId) : null,
        nomeParte: form.nomeParte,
        areaAcao: form.areaAcao,
        dataPrazo: form.dataPrazo,
        descricao: form.descricao,
        dataAudiencia: "",
        dataManifestacao: ""
      }

      // Define se é audiência ou prazo
      if (form.tipo === "audiencia") {
        novoCompromisso.dataAudiencia = form.dataPrazo
      } else {
        novoCompromisso.dataManifestacao = form.dataPrazo
      }

      // Aguarda a execução caso seja uma promise/operação assíncrona
      await adicionarCompromisso(novoCompromisso)

      alert("Compromisso lançado com sucesso!")

      setForm({
        tipo: "",
        colaboradorExecutor: "",
        colaboradorPrazoExecutar: "",
        processoId: "",
        nomeParte: "",
        areaAcao: "",
        dataPrazo: "",
        descricao: ""
      })
    } catch (error) {
      console.error("Erro ao adicionar compromisso:", error)
      alert("Ocorreu um erro ao lançar o compromisso.")
    } finally {
      setActionType(null) // 👈 Desativa o carregamento ao finalizar
    }
  }

  const tipoSelecionado = configTiposCompromisso[form.tipo]

  return (

    <div className="container">

      <div className="card">

        <h1>CADASTRAR COMPROMISSO</h1>

        <hr />

        <form onSubmit={handleSubmit}>

          <div className="form-grid">

            {/* TIPO */}

            <div className="form-group">

              <label>Tipo de compromisso</label>

              <select
                name="tipo"
                value={form.tipo}
                onChange={handleChange}
                required
              >

                <option value="">Selecione</option>

                {Object.entries(configTiposCompromisso).map(([key, tipo]) => (

                  <option key={key} value={key}>
                    {tipo.label}
                  </option>

                ))}

              </select>

            </div>

            {/* CAMPOS DINÂMICOS */}

            {tipoSelecionado?.campos.map((campo) => (

              <div className="form-group" key={campo.name}>

                <label>{campo.label}</label>

                {campo.tipo === "processo" ? (

                  <select
                    name={campo.name}
                    value={form[campo.name]}
                    onChange={handleChange}
                  >

                    <option value="">Selecione</option>

                    {processos.map((p) => (

                      <option key={p.id} value={p.id}>
                        {formatarNomeUpper(p.autor)} - {p.numeroProcesso}
                      </option>

                    ))}

                  </select>

                ) : campo.name === "colaboradorExecutor" ? (

                  <select
                    name={campo.name}
                    value={form[campo.name]}
                    onChange={handleChange}
                  >

                    <option value="">
                      Selecione o colaborador
                    </option>

                    {usuarios.map((usuario) => (

                      <option
                        key={usuario._id}
                        value={usuario.nome}
                      >
                        {formatarNomeUpper(usuario.nome)}
                      </option>

                    ))}

                  </select>

                ) : (

                  <input
                    type={campo.tipo}
                    name={campo.name}
                    value={form[campo.name]}
                    onChange={handleChange}
                  />

                )}

              </div>

            ))}

            {/* DESCRIÇÃO */}

            {form.tipo && (

              <div className="form-group full-width">

                <label>Descrição</label>

                {form.tipo === "outros" ? (

                  <textarea
                    name="descricao"
                    value={form.descricao}
                    onChange={handleChange}
                    rows={6}
                  />

                ) : (

                  <input
                    type="text"
                    name="descricao"
                    value={form.descricao}
                    onChange={handleChange}
                  />

                )}

              </div>

            )}

            {form.tipo && (

              <button 
                type="submit" 
                className="botao-primary" 
                disabled={actionType !== null}
              >
                {actionType === "salvar" ? (
                  <span className="spinner-loader"></span>
                ) : (
                  "Salvar Compromisso"
                )}
              </button>
            )}

          </div>

        </form>

      </div>

    </div>

  )

}

export default LancarCompromisso